import React from 'react';
import './NoPageFoundPage.css';

const NoPageFoundPage = () => {
    return (
        <div>
            NoPageFoundPage
        </div>
    );
};

export default NoPageFoundPage;